import React, { ReactNode } from 'react';
import {
  ToolbarCollectionEmptyStateBase,
  ToolbarCollectionEmptyStateBaseProps,
} from './ToolbarCollectionEmptyStateBase';
import { useCollectionContext } from '../CollectionContext';
import { observer } from 'mobx-react-lite';
import { ErrorBoundary } from '../ErrorBoundary';

export interface ToolbarCollectionEmptyStateFallbackProps
  extends Partial<ToolbarCollectionEmptyStateBaseProps> {
  children?: ReactNode;
}

const MagnifyingGlassArt = React.lazy(() =>
  import(
    /* webpackChunkName: "MagnifyingGlassArt" */ '../MagnifyingGlassArt'
  ).then(({ MagnifyingGlassArt }) => ({ default: MagnifyingGlassArt })),
);

const AddItemEmptyState = React.lazy(() =>
  import(
    /* webpackChunkName: "AddItemEmptyState" */ '../Illustration/AddItemEmptyState'
  ).then(({ AddItemEmptyState }) => ({ default: AddItemEmptyState })),
);

function _ToolbarCollectionEmptyStateFallback(
  props: ToolbarCollectionEmptyStateFallbackProps,
) {
  const state = useCollectionContext();

  const {
    result: { originQuery, hasAvailableItems },
    query: { hasNonPersistentActiveFilters },
  } = state;

  const { search } = originQuery;

  let image;

  if (hasAvailableItems && (search != null || hasNonPersistentActiveFilters)) {
    image = (
      <ErrorBoundary fallback={null}>
        <React.Suspense fallback={null}>
          <MagnifyingGlassArt data-hook="empty-state-glass-illustration" />
        </React.Suspense>
      </ErrorBoundary>
    );
  } else {
    image = (
      <ErrorBoundary fallback={null}>
        <React.Suspense fallback={null}>
          <AddItemEmptyState data-hook="empty-state-new-item-illustration" />
        </React.Suspense>
      </ErrorBoundary>
    );
  }

  return <ToolbarCollectionEmptyStateBase image={image} {...props} />;
}

export const ToolbarCollectionEmptyStateFallback = observer(
  _ToolbarCollectionEmptyStateFallback,
);
